import { FC } from 'react'
import { Row, Col, Text } from '@/client/components'
import * as S from './styles'
import { AdvantagesProps } from '../types'

/** TrustedShops carousel by locale */
const trustedShopCarouselByLocale: Record<string, string> = {
  es: 'wdg-89acb97a-32b6-47b0-b7f4-dbbceba4f0e8',
  it: 'wdg-f35f5e48-f95f-4e7a-aba0-ff5ddf43ca1a',
  nl: 'wdg-22088f3f-c6a2-478d-9d67-b6cded9d295c',
  fr: 'wdg-966fca0f-0b82-443e-af31-fd932a132a40',
  uk: 'wdg-c3a4df55-3ad4-4811-8864-ed6e68b3a086',
  de: 'wdg-9058ddc8-95bd-47a6-bcd9-137e360de04a'
}
const defaultLocale = process.env.NEXT_PUBLIC_DEFAULT_LOCALE
const trustedShopCarousel = defaultLocale ? trustedShopCarouselByLocale[defaultLocale] : undefined

const Advantages: FC<AdvantagesProps> = ({ advantages: { title } }) => (
  <S.Advantages>
    <S.Container>
      <Row>
        {trustedShopCarousel && (
          <Col>
            <Text size='xlg' as='h2' family='heading' weight='bold' margin='0 0 0.5rem'>
              {title}
            </Text>
            {/*  @ts-ignore */}
            <etrusted-widget data-etrusted-widget-id={trustedShopCarousel}></etrusted-widget>
          </Col>
        )}
      </Row>
    </S.Container>
  </S.Advantages>
)

export default Advantages
